import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { Form } from 'formik';

// CONSTANTS
import { WHITE } from '@/constants/colors';

export const FormStyled = styled(Form)`
  .zipcode,
  &.zipcode {
    &__input {
      background-color: ${WHITE};

      .MuiInputBase-input {
        padding-top: 21px;
      }
      .MuiOutlinedInput-adornedEnd {
        padding-right: 5px;
      }
      ::placeholder {
        color: ${p => p.theme.palette.text.primary};
      }

      .MuiFormHelperText-root {
        position: absolute;
        top: 100%;
      }
    }

    &__input-label {
      color: ${p => p.theme.palette.text.primary};
    }

    &__button {
      padding: 17px 46px;
      border-radius: 4px;
    }
  }
`;

export const DialogStyled = styled(Dialog)`
  .dialog,
  &.dialog {
    &__close-button {
      position: absolute;
      top: 6px;
      right: 6px;
      font-size: 30px;
      color: ${p => p.theme.palette.text.secondary};
    }

    &__title {
      max-width: 540px;
      margin: 0 auto;
      padding-top: 56px;
    }

    &__content {
      padding-bottom: 32px;
    }

    &__actions {
      padding: 16px;
    }

    &__button {
      width: 151px;
    }
  }
`;
